import { render } from "./EditOperation.vue?vue&type=template&id=0488c006&scoped=true"
import script from "./EditOperation.vue?vue&type=script&lang=js"
export * from "./EditOperation.vue?vue&type=script&lang=js"

import "./EditOperation.vue?vue&type=style&index=0&id=0488c006&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0488c006"]])

export default __exports__